<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>Topic</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="8">
                <CForm>
                  <CInput
                    label="Topic Name"
                    v-model="subjectUnit.unitName"
                    placeholder="Topic Name..."
                    horizontal
                    autocomplete="name"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Topic Name'"
                    :is-valid="
                      $v.subjectUnit.unitName.$dirty
                        ? !$v.subjectUnit.unitName.$error
                        : null
                    "
                    @blur="$v.subjectUnit.unitName.$touch()"
                  />

                  <CInputCheckbox
                    class="mr-2 d-inline-block"
                    :checked.sync="subjectUnit.needSubscriptionToPlay"
                    label="Paid Unit"
                    :inline ="false"
                    :disabled="mode.viewMode"
                  />

                  <CInput
                    label="Order Code"
                    v-model="subjectUnit.orderCode"
                    placeholder="Order of this unit..."
                    horizontal
                    :disabled="mode.viewMode"
                    type="number"
                    :invalid-feedback="'Please Enter the Order'"
                  />

                  <CTextarea
                    label="Topic  Description"
                    v-model="subjectUnit.unitDescription"
                    placeholder="Topic Description..."
                    horizontal
                    row="6"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Description'"
                    :is-valid="
                      $v.subjectUnit.unitDescription.$dirty
                        ? !$v.subjectUnit.unitDescription.$error
                        : null
                    "
                    @blur="$v.subjectUnit.unitDescription.$touch()"
                  />

                  <CTextarea
                    label="Notes"
                    v-model="subjectUnit.notes"
                    placeholder="Notes..."
                    horizontal
                    row="6"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Notes'"
                  />

                  <CInput
                    label="Duration in Minutes"
                    v-model="subjectUnit.duration"
                    placeholder="Duration..."
                    horizontal
                    type="number"
                    onKeyPress="if(this.value.length==3) return false;"
                    :disabled="mode.viewMode"
                    :invalid-feedback="'Please Enter the Duration'"
                    :is-valid="
                      $v.subjectUnit.duration.$dirty
                        ? !$v.subjectUnit.duration.$error
                        : null
                    "
                    @blur="$v.subjectUnit.duration.$touch()"
                  >
                    <template #description>
                      <CRow>
                        <CCol md="12">
                          <small class="form-text text-muted">Mins</small>
                        </CCol>
                      </CRow>
                    </template>
                  </CInput>

                  <div v-if="mode.newMode || mode.editMode">
                    <CInputFile
                      label="Select PDF"
                      horizontal
                      type="file"
                      :disabled="mode.viewMode"
                      accept=".pdf"
                      @change="uploadImage"
                      :is-valid="
                        $v.subjectUnit.pdfId.$dirty
                          ? !$v.subjectUnit.pdfId.$error
                          : null
                      "
                      @blur="$v.subjectUnit.pdfId.$touch()"
                    />

                    <CInputFile
                      label="Select Video"
                      horizontal
                      type="file"
                      :disabled="mode.viewMode"
                      accept=".mp4"
                      @change="uploadVideo"
                      :invalid-feedback="'Please Upload the Video'"
                      :is-valid="
                        $v.subjectUnit.video.videoId.$dirty
                          ? !$v.subjectUnit.video.videoId.$error
                          : null
                      "
                      @blur="$v.subjectUnit.video.videoId.$touch()"
                    >
                      <template #description>
                        <CRow>
                          <CCol md="12">
                            <small class="form-text text-muted"
                              >Please note, on uploading video, previous video
                              will get removed.</small
                            >
                          </CCol>
                        </CRow>
                      </template></CInputFile
                    >
                  </div>

                  <div
                    class="form-group row"
                    v-if="
                      (mode.viewMode || mode.editMode) &&
                      subjectUnit.video.status == 'success'
                    "
                  >
                    <label
                      for="example-text-input text-right"
                      class="col-sm-3 col-form-label"
                      >Hls Video :<span
                        v-if="mode.viewMode || mode.editMode"
                        style="color: red"
                        >*</span
                      ></label
                    >
                    <div class="col-sm-9">
                      <hls-input
                        :value.sync="subjectUnit.video.hlsUrl"
                        :disabled="mode.viewMode || mode.editMode"
                        media-type="video"
                        media-access-level="private"
                        :file-details-url="getFileDetailUrl()"
                        :upload-url="getUploadUrl()"
                        :play-btn="true"
                        :upload-btn="false"
                      ></hls-input>
                    </div>
                  </div>
                  <div class="vld-parent">
                    <loading
                      :active.sync="isLoading"
                      :is-full-page="fullPage"
                    ></loading>
                  </div>
                  <div
                    v-if="
                      (mode.viewMode || mode.editMode) &&
                      subjectUnit.video.status == 'success'
                    "
                  >
                    <CInput
                      label="ThumbnailUrl"
                      v-model="subjectUnit.video.thumbnailUrl"
                      placeholder="thumbnail Url..."
                      horizontal
                      :disabled="mode.viewMode || mode.editMode"
                    />
                    <CRow>
                      <CCol md="4" />
                      <CCol md="6">
                        <CImg
                          v-if="subjectUnit.video.thumbnailUrl"
                          :src="subjectUnit.video.thumbnailUrl"
                          height="180px"
                          alt="Responsive image"
                          :disabled="mode.viewMode"
                      /></CCol>
                    </CRow>
                  </div>
                </CForm>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter align="right">
            <CButton
              class="mr-2"
              v-if="mode.viewMode && subjectUnit.video.status != 'pending'"
              type="submit"
              color="secondary"
              @click="editMode()"
              >Edit</CButton
            >
            <CButton
              class="mr-2"
              v-if="!mode.viewMode"
              type="submit"
              color="success"
              @click="saveSubject()"
              >Save</CButton
            >
            <CButton class="mr-2" type="Cancel" color="danger" @click="cancel()"
              >Cancel</CButton
            >
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
// import Vue from "vue";
// import VueCoreVideoPlayer from 'vue-core-video-player'
// Vue.use(VueCoreVideoPlayer)
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import MultiSelect from "../../containers/MultiSelect";
import HlsPlayer from "../../containers/HlsPlayer";
import HlsInput from "../../containers/HlsInput";
import { Chrome } from "vue-color";

import {
  required,
  minLength,
  maxLength,
  url,
  requiredIf,
} from "vuelidate/lib/validators";
export default {
  name: "Unit",
  components: {
    MultiSelect,
    HlsPlayer,
    HlsInput,
    "chrome-picker": Chrome,
    Loading,
  },
  data() {
    return {
      mode: {
        newMode: false,
        editMode: false,
        viewMode: false,
      },
      unitId: "",
      sectionId: "",
      isLoading: false,
      fullPage: true,

      subjectUnit: {
        sectionId: this.$route.params.sectionId,
        courseId: this.$route.params.courseId,
        unitId: "",
        unitName: "",
        orderCode: 0,
        unitDescription: "",
        needSubscriptionToPlay: true,
        duration: "",
        pdfId: "",
        notes: "",
        courseVideoId: "",
        video: {
          hlsUrl: "",
          thumbnailUrl: "",
          videoId: "",
        },
      },
    };
  },
  validations: {
    subjectUnit: {
      unitName: {
        required,
      },
      unitDescription: {
        required,
      },
      duration: {
        required,
      },
      //  duration:{
      //      required,
      //  },
      pdfId: {
        //required,
      },
      courseVideoId: {
        //  required,
      },
      video: {
        videoId: {
          required,
        },
      },
    },
  },
  created() {
    if (this.$route.params.mode == "new") {
      this.mode.newMode = true;
      this.mode.viewMode = false;
      this.mode.editMode = false;
      this.sectionId = this.$route.params.sectionId;
      this.courseId = this.$route.params.courseId;
    }
    if (this.$route.params.mode == "view") {
      this.mode.viewMode = true;
      this.sectionId = this.$route.params.sectionId;
      this.unitId = this.$route.params.unitId;
      // this.courseId=this.$route.params.courseId;
      this.getSubject();
    } else if (this.$route.params.mode == "edit") {
      this.mode.editMode = true;
      this.sectionId = this.$route.params.sectionId;
      this.unitId = this.$route.params.unitId;
      this.courseId = this.$route.params.courseId;
      this.getSubject();
    }
  },
  methods: {
    getFileDetailUrl() {
      const url = process.env.VUE_APP_API_HOST + "/file/{fileId}/details";
      console.log("getFileDetailUrl()", url);
      return url;
    },
    getUploadUrl() {
      const url = process.env.VUE_APP_API_HOST + "/file/video/upload";
      console.log("getUploadUrl()", url);
      return url;
    },

    doAjax() {
      this.isLoading = true;
      // simulate AJAX
    },
    open() {
      console.log("open was clicked, will auto hide");
      let loader = this.$loading.show({
        loader: "dots",
      });
      setTimeout(() => loader.hide(), 3 * 1000);
    },
    show() {
      console.log("show was clicked, click to hide");
      // do AJAX here
      this.visible = true;
    },
    editMode() {
      this.mode.editMode = true;
      this.mode.viewMode = false;
    },
    cancel() {
      this.$router.push({
        name: "Units",
        params: { sectionId: this.$route.params.sectionId },
      });
      // this.$router.push({ name: "Subjects"});
    },

    getSubject() {
      this.apiGetSecure(
        process.env.VUE_APP_API_HOST + "/web/secure/subject/unit/" + this.unitId
      )
        .then((response) => response.json())
        .then((data) => (this.subjectUnit = data));
    },

    uploadImage(files, event) {
      const URL = process.env.VUE_APP_API_HOST + "/file/video/upload";
      console.log("uploadImage", URL);
      console.log("files", files);
      console.log("event", event);
      let fdata = new FormData();
      fdata.append("file", files[0]);

      // fdata.append("courseId","courseId");
      fdata.append("pdfId", "fileId");

      fetch(URL, {
        method: "POST",
        body: fdata,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("image upload response > ", data);
          // this.service.image = data.data.fileId;
          alert("Your PDF is uploaded");

          this.subjectUnit.pdfId = data.data.fileId;
        });
    },
    uploadVideo(files, event) {
      this.isLoading = true;
      const URL = process.env.VUE_APP_API_HOST + "/file/video/upload";
      console.log("uploadVideo", URL);
      console.log("files", files);
      console.log("event", event);
      let fdata = new FormData();
      fdata.append("file", files[0]);

      // fdata.append("courseId","courseId");
      fdata.append("courseVideoId", "fileId");

      fetch(URL, {
        method: "POST",
        body: fdata,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("image upload response > ", data);
          // this.service.image = data.data.fileId;
          // alert("Your Video is uploaded");
          this.isLoading = false;

          this.subjectUnit.video.videoId = data.data.fileId;
          this.subjectUnit.video.status = "pending";
          this.subjectUnit.video.hlsUrl = "";
          this.subjectUnit.video.thumbnailUrl = "";
        });
    },

    validator(val) {
      return val ? val.length >= 4 : false;
    },

    saveSubject() {
      this.$v.subjectUnit.$touch();
      if (this.$v.subjectUnit.$invalid) {
        console.log("form is invalid", JSON.stringify(this.$v.subjectUnit));
      } else {
        this.apiPostSecure(
          process.env.VUE_APP_API_HOST + "/web/secure/save/subject/unit",
          this.subjectUnit
        ).then((post) => {
          this.$router.push({
            name: "Units",
            params: { sectionId: this.$route.params.sectionId },
          });
          // this.$router.push({ name: "Subjects"});
        });
      }
    },
  },
  mounted() {},
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
